import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { getComponentClasses } from '@99designs/common/utils/app';

class PromoBar extends React.Component {
    render() {
        const classes = classNames(getComponentClasses('promo-bar', this.props.variations), {
            'promo-bar--active': this.props.active,
            'promo-bar--dismissible': this.props.dismissible,
        });

        const dismissButton = (
            <button onClick={this.props.onDismiss} className="promo-bar__dismiss" />
        );

        return (
            <div className={classes}>
                <div className="promo-bar__message" data-testid="promo-bar__message">
                    <p className="promo-bar__message__item">{this.props.children}</p>
                </div>
                {this.props.dismissible && dismissButton}
            </div>
        );
    }
}

PromoBar.propTypes = {
    active: PropTypes.bool,
    dismissible: PropTypes.bool,
    onDismiss: PropTypes.func,
    variations: PropTypes.array,
};

PromoBar.defaultProps = {
    active: false,
    dismissible: false,
    onDismiss: () => {},
    variations: [],
};

class PromoBarAction extends React.Component {
    render() {
        const classes = getComponentClasses('promo-bar__message__action', this.props.variations);

        return (
            <a href="#" className={classes}>
                {this.props.children}
            </a>
        );
    }
}

PromoBarAction.propTypes = {
    variations: PropTypes.array,
};

PromoBarAction.defaultProps = {
    variations: ['cta'],
};

export default PromoBar;
export { PromoBar, PromoBarAction };
